module.exports = __webpack_public_path__ + "img/trees.d4385567.png";